const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeSupportingStaffEmail = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const isValidSupportingStaffEmail = (value) => {
  const email = normalizeSupportingStaffEmail(value);
  return email.length <= 254 && EMAIL_PATTERN.test(email);
};

export const employeeSupportingStaffOption = (employee) => {
  const employeeId = typeof employee === 'object' ? employee?._id || employee?.Id || employee?.value : employee;
  const label =
    employee?.DisplayName ||
    employee?.label ||
    [employee?.FirstName, employee?.LastName || employee?.FamilyName].filter(Boolean).join(' ');
  return {
    value: `employee:${employeeId}`,
    employeeId,
    label: label || 'Employee',
    recipientType: 'employee'
  };
};

export const externalSupportingStaffOption = (contact) => {
  const email = normalizeSupportingStaffEmail(contact?.email || contact?.value);
  return {
    value: `email:${email}`,
    email,
    contactId: contact?._id || contact?.contactId,
    label: contact?.name || contact?.label || email,
    recipientType: 'external'
  };
};

export const createExternalSupportingStaffOption = (inputValue) => {
  const email = normalizeSupportingStaffEmail(inputValue);
  return isValidSupportingStaffEmail(email) ? externalSupportingStaffOption({ email, name: email }) : null;
};

export const taskSupportingStaffOptions = (task = {}) => [
  ...(task.supportingStaff || [])
    .map((staff) => staff?.employeeId)
    .filter(Boolean)
    .map(employeeSupportingStaffOption),
  ...(task.externalRecipients || [])
    .filter((recipient) => !recipient.role || recipient.role === 'supportingStaff')
    .map(externalSupportingStaffOption)
];

export const splitSupportingStaffOptions = (options = []) => ({
  supportingStaff: options
    .filter((option) => option?.recipientType === 'employee' && option.employeeId)
    .map((option) => ({ employeeId: option.employeeId })),
  externalRecipients: options
    .filter((option) => option?.recipientType === 'external' && option.email)
    .map((option) => ({
      ...(option.contactId ? { contactId: option.contactId } : {}),
      name: option.label || option.email,
      email: normalizeSupportingStaffEmail(option.email),
      role: 'supportingStaff'
    }))
});

export const sameSupportingStaffOptions = (left = [], right = []) =>
  left
    .map((option) => option.value)
    .sort()
    .join(',') ===
  right
    .map((option) => option.value)
    .sort()
    .join(',');
